/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/frame_ship_corvette': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M3 13.254H2v-5.29L6.587 5.33l.498.867L3 8.543zM8.764 5.233l-.498-.867 1.68-.965.498.868zM20.087 3.424L16 1.077l-4.087 2.347-.498-.867L16-.077l4.585 2.634zM23.446 5.353l-1.68-.964.498-.867 1.68.964zM30 13.254h-1V8.543l-4.085-2.346.498-.867L30 7.964zM29 15.165h1v1.911h-1zM25.413 26.671l-.498-.866L29 23.458v-4.71h1v5.29zM22.055 28.6l-.498-.868 1.68-.964.497.867zM16 32.077l-4.585-2.634.498-.866L16 30.923l4.087-2.346.498.866zM9.736 28.481l-1.679-.965.498-.867 1.679.965zM6.587 26.671L2 24.038v-5.29h1v4.71l4.085 2.347zM2 14.926h1v1.911H2z"/>'
  }
})
